/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { useRouter } from 'next/router';
import DrawBlob from 'blob-animated';

import { useTranslation } from '../../hooks/translation';
import AppImage from '../AppImage';
import AppLink from '../AppLink';
import AppPersonCard from '../AppPersonCard/AppPersonCard';

import styles from './AppBlogCard.module.scss';
export default function AppBlogCard({ backLink, blog, hoverNone, linkNone }) {
  const { translate } = useTranslation();
  const router = useRouter();
  let backPath = router.query.parent;

  const canvasRef = React.useRef(null);
  const canvasImageRef = React.useRef(null);

  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const Blob = new DrawBlob({
      canvas: canvasRef.current,
      maskedElement: canvasImageRef.current,
      speed: 100,
      scramble: 0.1,
    });
  }, []);

  return (
    <div className={styles.AppBlogCard}>
      <div className={styles.AppBlogCard_Content}>
        {backLink && (
          <AppLink href={backPath || '/'} className={styles.AppBlogCard_Back}>
            <Arrow_Left />
            <span>Go Back</span>
          </AppLink>
        )}
        <div className={styles.AppBlogCard_About}>
          <strong>{blog?.category?.title}</strong>
          <span>
            {blog?.read_time} {translate('min_read')}
          </span>
        </div>

        {linkNone ? (
          <>
            <h1 className={`${styles.AppBlogCard__Title} ${hoverNone && styles.inner_title}`}>
              {blog?.title}
            </h1>
          </>
        ) : (
          <>
            <AppLink href={`${blog?.parent_slug}/${blog?.slug}`} title={blog?.title} ariaLabel={blog?.title}>
              <h2 className={`${styles.AppBlogCard__Title} ${hoverNone && styles.inner_title}`}>
                {blog?.title}
              </h2>
            </AppLink>
          </>
        )}
        <div className={styles.AppBlogCard__Text}>{blog?.desc}</div>
        <AppPersonCard author={blog?.team} />
      </div>
      <div className={styles.AppBlogCard_Frame}>
        <AppImage objectFit="fill" src="/images/about-frame-1.svg" alt='frame'/>
        <div className={styles.AppBlogCard_Frame_Image}>
          <img ref={canvasImageRef} src={blog?.bg.thumbnails[ '970x620' ]} alt={blog.title} title={blog.title} style={{ display: 'none' }} />
          <canvas
            ref={canvasRef}
            id="canvasExample"
            className={styles.AppBlogCard_Frame_Image_Main}
          />
        </div>
      </div>
    </div>
  );
}

function Arrow_Left() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8327 10H4.16602M4.16602 10L9.99935 15.8333M4.16602 10L9.99935 4.16667"
        stroke="black"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
